<template>
    <div>
        <h2 class="text-dark mt-2 mb-2 font-doc-head">
            Document download
        </h2>
        <hr class="mt-2">
        <b-button size="sm" class="text-capitalize btn-custom font-btn mr-2" variant="info">Department -1</b-button>
        <b-button size="sm" class="text-capitalize btn-custom font-btn mr-2" variant="info">Department -2</b-button>
        <b-button size="sm" class="text-capitalize btn-custom font-btn mr-2" variant="info">Department -3</b-button>
        <div class="mt-3 bg-custom">
            Department : xxxxxxx
            <b-table class="mt-3 font-table" hover :fields="fields" :items="items">
                <template v-slot:cell(list)="row">
                    <div class="mt-1 mb-1 row zoom-list-file">
                        <div class="col-md-8">
                            <b-media>
                                <template v-slot:aside>
                                    <i class="fa fa-file fa-2x"></i>
                                </template>
                                <h5 class="mt-2 mb-0 font-table"><i class="mr-2">Document :</i>Nested Media</h5>
                                <p class="mb-2 font-table">
                                    Subscribe : Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in
                                    faucibus.
                                </p>
                                <p class="mb-2 mt-0 font-table">
                                    <i class="fa fa-calendar mr-2"></i>Update : xxxx-xx-xx
                                </p>
                            </b-media>
                        </div>
                        <div class="col-md-4"></div>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                fields: [
                    { 
                        key: 'list', 
                        label: '',
                        thStyle: 
                        { 
                            backgroundColor: '#ebe1f1a1',
                            border:'0px solid #fff',
                            width:'100%',
                            height:'1%',
                            color: '#000'
                        } 
                    },
                ],
                items: [
                    { list: 40 },
                    { list: 21 },
                    { list: 89 },
                    { list: 38 },
                ]
            }
        },
        methods: {}
    }
</script>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Baloo+Tamma+2&family=Varela+Round&display=swap');
    @import url('https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.0.0/animate.min.css');
    .f-500{ font-weight: 500; }
    // .zoom-list-file{ transition: transform .05s; /* Animation */ }
    .zoom-list-file:hover { transform :scale(1.1); margin-left: 55px; }
    .font-doc-head{ font-family: 'Baloo Tamma 2', cursive !important; }
    .font-btn{ 
        font-family: 'Baloo Tamma 2', cursive !important;
        font-size: 1rem;
        font-weight: 500;
    }
    .font-table{ font-family: 'Baloo Tamma 2', cursive !important; }
    .card-custom {
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
        border-radius: 15px;
        background-color: #e1f2f573;
    }
    .bg-custom{
        background-color: #ebe1f1a1;
        padding: 20px;
        border-radius: 15px;
    }
    .btn-custom{
        border-radius: 5px;
    }
</style>